import { useEffect, useState } from "react";
import _ from "lodash";
import React, { useRef } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const ContactSheet = ({ photoshootDetails, photoshootImages }) => {
  const sheetRef = useRef();
  const [downloaded, setDownloaded] = useState(false);

  const handleDownloadPDF = async () => {
    const input = sheetRef.current;
    if (!input) return;
    // Scroll to top to ensure all images are loaded
    window.scrollTo(0, 0);
    // Wait for images to load
    const images = input.querySelectorAll("img");
    await Promise.all(
      Array.from(images).map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = img.onerror = resolve;
        });
      }),
    );
    // Use html2canvas on the grid only
    const canvas = await html2canvas(input, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    // Fit image to page width, scale height
    const imgProps = pdf.getImageProperties(imgData);
    let pdfWidth = pageWidth;
    let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    if (pdfHeight > pageHeight) {
      pdfHeight = pageHeight;
      pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
    }
    if (imgData.startsWith("data:image/png")) {
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    }
    pdf.save("contact-sheet.pdf");
  };

  const hasDownloadedRef = useRef(false);

  useEffect(() => {
    if (hasDownloadedRef.current) return;
    hasDownloadedRef.current = true;
    handleDownloadPDF();
  }, []);

  return (
    <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
      <div ref={sheetRef} className="grid grid-cols-4">
        {photoshootImages
          .filter((item) => item.status === "bt-approved")
          .map((item, index) => (
            <div
              key={item.id}
              className="flex flex-col items-center p-2"
              style={{ minWidth: 220, minHeight: 300 }}
            >
              <img
                src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                className="mb-1 object-contain"
                width={200}
                height={200}
              />
              <div
                className="text-xs font-medium text-center break-all truncate w-180"
                style={{
                  width: "200px",
                  lineHeight: "1.2",
                  minHeight: "32px",
                }}
              >
                {item.fname}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ContactSheet;
